<template>
  <div
    class="modal fade"
    id="versionInfoRModal"
    tabindex="-1"
    aria-labelledby="versionInfoRModallLabel"
    aria-hidden="true"
    style="overflow-x: hidden"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header text-center">
          <div class="modal_header_flex" >
            <h1 class="modal-title fs-5" id="staticBackdropLabel">
              웹 버전 정보 보기
            </h1>
          </div>
        </div>
        <div class="modal-division"/>
        <div class="modal-body" style="padding-top: 1rem">

          <div class="modalDivWrap">
            <div class="modalPartTitle">웹 버전 정보</div>
            <div class="modalInputDiv">
              <label for="">웹 유형</label>
              <input
                type="text"
                v-model="computedServiceType"
                disabled
              />
            </div>
            <div class="modalInputDiv">
              <label for="">버전</label>
              <input
                type="text"
                v-model="version"
                disabled
              />
            </div>
            <div class="modalInputDiv">
              <label for="">패치노트</label>
              <textarea style="
                width: 60%;
                border-radius: 5px;
                border-width: 1px;
                height: 75px;
                resize: none;
                " v-model="patchNote"
                disabled    
              >
              </textarea>
            </div>
            <div class="modalInputDiv">
              <label for="">라이브 버전 여부</label>
              <span style="color: black"> {{ liveVersionYn === "Y" ? "예" : "아니오"}} </span>
              <div class="modalInputRight"/>
            </div>
          </div>
        </div>
        <div class="modal-footer" style="justify-content: center">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
            style="color: #666666; background: #fff; border: 1px solid #666;"
          >
            닫기
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ServiceTypeEnum } from "@/enums/common.enums";

export default {
  data() {
    return {
      serviceTypesList: [], // 웹 유형 가져오기
      versionId: "", // 버전 Id
      serviceType: "", // 버전 Id
      version: "", // 버전
      patchNote: "", // 패치노트
      liveVersionYn: "", // 라이브 버전 여부
    };
  },
  props: {
    data: {
      versionId: {
        type: String,
        required: false
      },
      serviceType: {
        type: String,
        required: false
      },
      version: {
        type: String,
        required: false
      },
      patchNote: {
        type: String,
        required: false
      },
      liveVersionYn: {
        type: String,
        required: false
      },
    }
  },
  async mounted() {
    this.serviceTypesList = ServiceTypeEnum;
    this.initValues();
  },
  computed: {
    computedServiceType() {
      if(!this.serviceTypesList.length === 0) return '';
      if(!this.serviceType) return '';
      if(!this.serviceTypesList[this.serviceType]?.name) return '';
      return this.serviceTypesList[this.serviceType].name;
    },
  },
  watch: {
    data: {
      immediate: true,
      deep: true, 
      async handler(newValue, oldValue) {
        if(newValue && newValue.versionId !== this.versionId) {
          this.initValues();
          if(newValue.versionId) this.versionId = newValue.versionId;
          if(newValue.serviceType) this.serviceType = newValue.serviceType;
          if(newValue.version) this.version = newValue.version;
          if(newValue.forceUpdateYn) this.forceUpdateYn = newValue.forceUpdateYn;
          if(newValue.patchNote) this.patchNote = newValue.patchNote;
          if(newValue.liveVersionYn) this.liveVersionYn = newValue.liveVersionYn;          
        }
      }
    }
  },
  methods: {
  // 기타 versionInfoR용 utils

  // 항목 초기화 용도
  initValues() {
    this.version = "";
    this.serviceType = "";
    this.patchNote = "";
    this.liveVersionYn = "";
  },
  },
};
</script>
